import { newOperation } from "@/utils/constants";
import { handleError, handleResponse } from "@/utils/functions";

export default (axios) => ({
  getTripAnalytics(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${newOperation.tripAnalyticsOperation}`, { params: params })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },

  getTripStats(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${newOperation.tripStatsOperation}`, { params: params })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },

  getFleetUtilization(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${newOperation.fleetUtilizationOperation}`, { params: params })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },

  getStorageUtilization(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${newOperation.storageUtilizationOperation}`, { params: params })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },

  getReasonIncompleteDelivery(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${newOperation.reasonUndeliveredOperation}`, { params: params })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },

  getOrderStatus(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${newOperation.orderStatusOperation}`, { params: params })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },

  getOrderVelocityByHour(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${newOperation.orderDeliveryVelocityOperation}`, {
          params: params,
        })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },

  getTripDelay(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${newOperation.tripDelayOperation}`, {
          params: params,
        })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },

  getMapInfo(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${newOperation.mapInfoOperation}`, {
          params: params,
        })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },

  getDriverList(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${newOperation.driverListOperation}`, {
          params: params,
        })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },

  getTripDriverCounts(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${newOperation.tripDriverCountsOperation}`, {
          params: params,
        })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },

  getTripKpi(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${newOperation.operationBase}${id}/get_trip_kpi/`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },

  getTripLogs(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${newOperation.tripLogsOperation}`, {
          params: params,
        })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
});
